module.exports = __webpack_public_path__ + "static/media/AgendaP.46a44708.jpg";